import moment from "moment/moment";

const CONF = window?.confPub;
const UI = CONF?.UI?.RECHERCHE_PERSONNE;
const INPUTS = UI?.INPUTS;
const ROUTES = CONF?.ROUTES;
const PATTERNS = CONF?.PATTERNS

export const fromIso8601ToDdSlashMmSlashYyyy = (dateIso8601) => {

    return moment(dateIso8601).format(PATTERNS?.DD_SLASH_MM_SLASH_YYYY)
}

export const fromIso8601ToYyyyDashMmDashDD = (dateIso8601) => {

    return moment(dateIso8601).format(PATTERNS?.YYYY_DASH_MM_DASH_DD)
}

export const fromDateInputToDdSlashMmSlashYyyy = (dateYyyyDashMmDashDd) => {

    const isValid = moment(dateYyyyDashMmDashDd).isValid()

    return isValid ? moment(dateYyyyDashMmDashDd).format(PATTERNS?.DD_SLASH_MM_SLASH_YYYY) : ""
}

export const isAfterToday = (dateToCheck) => {

    return moment(dateToCheck).isAfter(moment())
}

export const isBeforeToday = (dateToCheck) => {

    return moment(dateToCheck).isBefore(moment())
}

/**
 * Experimentale
 * @param start1
 * @param end1
 * @param start2
 * @param end2
 * @returns {boolean}
 */
export const arePeriodesOverlapping = (start1, end1, start2, end2) => {
    // TODO mettre pattern ? moment lit automatiquement les YYYY-MM-DD
    const debutPeriode1 = moment(start1, PATTERNS?.YYYY_DASH_MM_DASH_DD)
    const finPeriode1 = moment(end1, PATTERNS?.YYYY_DASH_MM_DASH_DD)
    const debutPeriode2 = moment(start2, PATTERNS?.YYYY_DASH_MM_DASH_DD)
    const finPeriode2 = moment(end2, PATTERNS?.YYYY_DASH_MM_DASH_DD)

    // return debutPeriode1.isBefore(finPeriode2) && finPeriode1.isAfter(debutPeriode2)
    return debutPeriode1.isBetween(debutPeriode2, finPeriode2)
        || finPeriode1.isBetween(debutPeriode2, finPeriode2)
        || debutPeriode2.isBetween(debutPeriode1, finPeriode1)
        || finPeriode2.isBetween(debutPeriode1, finPeriode1)
        || debutPeriode1.isSame(debutPeriode2)
        || finPeriode1.isSame(finPeriode2)
        || finPeriode1.isSame(debutPeriode2)
        || finPeriode2.isSame(debutPeriode1)
}

export const checkOverlappingPeriodes = (periodes, previousPeriodes) => {

    const newPeriodes = [...periodes]

    if (previousPeriodes?.length > 0) {
        previousPeriodes.forEach(periode => {

            newPeriodes.push({
                dateIndemnisationDebut: {
                    value: moment(periode?.dateIndemnisationDebut, PATTERNS?.DD_SLASH_MM_SLASH_YYYY)
                        .format(PATTERNS?.YYYY_DASH_MM_DASH_DD)
                },
                dateIndemnisationFin: {
                    value: moment(periode?.dateIndemnisationFin, PATTERNS?.DD_SLASH_MM_SLASH_YYYY)
                        .format(PATTERNS?.YYYY_DASH_MM_DASH_DD)
                },
            })
        })
    }

    for (let i = 0; i < newPeriodes.length; i++) {
        for (let j = i + 1; j < newPeriodes.length; j++) {
            const periode1 = newPeriodes[i]
            const periode2 = newPeriodes[j]

            // TODO voir pour variabiliser la partie dateIndemnisationDebut?.value
            if (arePeriodesOverlapping(periode1?.dateIndemnisationDebut?.value, periode1?.dateIndemnisationFin?.value,
                periode2?.dateIndemnisationDebut?.value, periode2?.dateIndemnisationFin?.value)) {
                return true
            }
        }
    }

    return false
}

export const sortPeriodesDescending  = (periodes) => {

    if (Array?.isArray(periodes)) {

        const DD_SLASH_MM_SLASH_YYYY = PATTERNS?.DD_SLASH_MM_SLASH_YYYY
        return periodes?.sort((a, b) => moment(b.dateIndemnisationDebut, DD_SLASH_MM_SLASH_YYYY) - moment(a.dateIndemnisationDebut, DD_SLASH_MM_SLASH_YYYY))

    } else {

        return []
    }
}